import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateCampanha } from 'campanha/src/store/campanhaReducer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CampanhaParameters } from '../../infra/routes/campanhaRoutes';
import { Container } from "base/src/components/Basic/Container/container"
import { useEffect } from 'react';
import { StatusRoute } from 'base/src/store/util/action/utilAction';
import { UsuarioSistemaPerfilEnum } from 'domain/types/usuarioSistemaPerfil/usuarioSistemaPerfilEnum';

const connector = connectUtil(
	(state: RootStateCampanha) => ({
		usuarioSistemaPerfil: state.UsuarioSistemaPerfilReducer.usuarioSistemaPerfil
	}),
	{ StatusRoute }
);

export interface ViewContainerProps extends PropsFromRedux<typeof connector> {
	children?: React.ReactNode;
}

function ViewContainer(props: ViewContainerProps) {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const campanhaId = searchParams.get(CampanhaParameters.campanhaId);

	useEffect(() => {
		if (campanhaId == null) {
			navigate('/error');
		}
	}, []);

	useEffect(() => {
		if (props.usuarioSistemaPerfil == null) { return }

		if (props.usuarioSistemaPerfil && props.usuarioSistemaPerfil.find(u =>
			u.PerfilID === UsuarioSistemaPerfilEnum.AdministradorDeCarteira
		)) {
			props.StatusRoute("pagarPedido", true);
			props.StatusRoute("aprovarPedido", true);
			props.StatusRoute("notaRepasse", true);
		} else {
			props.StatusRoute("pagarPedido", false);
			props.StatusRoute("aprovarPedido", false);
			props.StatusRoute("notaRepasse", false);
		}
	}, [props.usuarioSistemaPerfil]);

	return (
		campanhaId &&
		(
			<Container>
				{props.children}
			</Container>
		)
	);
}

export default connector(ViewContainer);
